import React, { useState, useEffect } from "react";
import "./DiscountBanners.scss";
import { Skeleton } from "@material-ui/lab";
import { get_lang } from "../../../../global-functions/apiGlobal";
import noRewardImg from "../../../js/assets/images/no-reward-img.png";
import boubyanImg from "../../../js/assets/images/bobeyan.png";

import { useSelector } from "react-redux";
import OfferRedemptionPopup from "../offerRedemptionPopup/OfferRedemptionPopup";

const DiscountBanners = (props) => {
  const { data, isLoadingCardDiscounted } = props;
  const appState = useSelector((state) => state);

  const [showOfferPopup, setShowOfferPopup] = useState(false);
  const [offerData, setOfferData] = useState(null);

  const handleShowOfferPopup = (id) => {
    setShowOfferPopup(true);
    setOfferData(data.find(item => item.id === id));
  }

  // const offerData = {
  //   image: boubyanImg,
  //   discount: "0.550 KD",
  //   points: "500",
  //   minSpend: "4.5",
  //   validDays: "14"
  // };

  return (
    <>
      {showOfferPopup && (
        <OfferRedemptionPopup
          offer={offerData}
          onClose={() => setShowOfferPopup(false)}
        />
      )}
   

      <section
        id="discount-banners"
        className="discount-banner-container p-0 mt-3 mx-3 d-flex flex-nowrap justify-content-between align-items-center overflow-x-auto"
      >
        {isLoadingCardDiscounted ? (
          //  loading behavior like lazy loading like skeleton loading
          <div className="discount-banner d-flex justify-content-between align-items-center">
            <Skeleton width={400} height={30} />
            <Skeleton width={100} height={30} />
          </div>
        ) : (
          data.map((item, index) => (
            <div key={index} className="discount-banner d-flex justify-content-between align-items-center">
              <div className="discount-text cursorPointer" onClick={() => handleShowOfferPopup(item.id)}>
                {item.discount}% {get_lang(item.name, appState.langValue)}    
              </div>
              <div className="discount-action">
                <img
                  src={boubyanImg}
                  alt="discount icon"
                  width={50}
                  // height={24}
                />
              </div>
            </div>
          ))
        )}
      </section>
    </>
  );
};

export default DiscountBanners;
